module.exports = __webpack_public_path__ + "static/media/carousel6.fcbe52be.jpg";